import { useEffect, useState } from "react";
import folder from "../../assets/images/folder.svg";
import fileIcon from "../../assets/images/fileGrey.svg";

const FileStructure = ({
  data,
  getGitRepoFileContent,
  selectedFile,
  handleFileSelection,
}) => {
  
  
  const [expand, setExpand] = useState({});
  return (
    <>
      <div style={{ marginLeft: "5px" }}>
        {data?.map((item) => {
          if (item?.type === "dir") {
            return (
              <div className="code-folder-structure-single-folder">
                <div
                  className="folder-title cursor-pointer"
                  onClick={() => {
                    if (expand[item?.path]) {
                      delete expand[item?.path];
                    } else {
                      expand[item?.path] = item?.path;
                    }
                    setExpand({ ...expand });
                  }}
                >
                  <img src={folder} alt="folder" />
                  <h6>{item?.name}</h6>
                </div>
                <div className={expand[item?.path] ? "folder-body" : "d-none"}>
                  <FileStructure
                    data={item?.child}
                    getGitRepoFileContent={getGitRepoFileContent}
                    selectedFile={selectedFile}
                    handleFileSelection={handleFileSelection}
                  />
                </div>
              </div>
            );
          } else {
            return (
              <div className="code-folder-structure-single-folder">
                <div
                  className="cursor-pointer d-flex align-items-center gap-2"
                  onClick={(e) => {
                    e.preventDefault();
                    getGitRepoFileContent(item?.path);
                  }}
                >
                  <img src={fileIcon} alt="fileIcon" />
                  <p>{item?.name}</p>
                </div>
              </div>
            );
          }
        })}
      </div>
    </>
  );
};

export default FileStructure;
